import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import PrivacyPolicy from '../components/PrivacyPolicy'

const Privacypage = () => {
  return (
    <div>
    <Navbar/>
    <PrivacyPolicy/>


    <Footer/>

    </div>
  )
}

export default Privacypage